import { loadScript } from '@utils/index';
import { processEnv } from '@utils/config';

const h5_fe_lib =
  processEnv.hostEnv == 'online'
    ? '//h5cdn.babytreeimg.com'
    : '//h5cdn-1.babytree-test.com';

export function lazyWLA() {
  if (window.WLA) {
    return Promise.resolve(window.WLA);
  }
  return loadScript(`${h5_fe_lib}/h5_fe_lib/release/wla/0.0.12/index.min.js`, {
    attrs: { crossorigin: 'anonymous' }
  }).then(() => {
    return window.WLA;
  });
}

export function lazyDingTalkSdk() {
  if (window.dingTalkSdk) {
    return Promise.resolve(window.dingTalkSdk);
  }
  return new Promise((resolve, reject) => {
    import('dingtalk-jsapi')
      .then(dingTalkSdk => {
        window.dingTalkSdk = dingTalkSdk.default;
        resolve(dingTalkSdk.default);
      })
      .catch(() => reject());
  });
}
